// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"151df3c3","453":"021193c7","455":"c56fa7fe"}[chunkId] + ".chunk.js";
};